import { FC } from 'react';

export const DefaultLayout: FC = ({ children }) => {
  return <>{children}</>;
};
